<template>
  <div class="act-topbar-container">
    <div class="header-section">
      <div class="page-title">
        <h3 class="title-text">我的活動</h3>
        <p class="subtitle-text">管理您的活動內容</p>
      </div>
    </div>
    
    <div class="content-section">
      <div class="search-section" v-if="newIndex > 0 && newIndex < 5">
        <a-input-search
          placeholder="請輸入活動名稱搜尋..."
          class="search-input"
          enter-button="搜尋"
          size="large"
          @search="onSearch"
        >
          <a-icon slot="prefix" type="search" />
        </a-input-search>
      </div>

      <div class="tabs-container">
        <b-tabs 
          v-model="newIndex" 
          content-class="tab-content-custom" 
          nav-class="nav-tabs-custom"
          v-on:activate-tab="tabActivated"
        >
          <b-tab>
            <template #title>
              <div class="tab-title">
                <i class="tab-icon">📝</i>
                <span>暫存檔</span>
              </div>
            </template>
            <div class="tab-panel">
              <ActableTmp v-if="newIndex==0" />
            </div>
          </b-tab>
          
          <b-tab>
            <template #title>
              <div class="tab-title">
                <i class="tab-icon">📄</i>
                <span>草稿</span>
              </div>
            </template>
            <div class="tab-panel">
              <Actable v-if="newIndex-1==0" :ids="converts(newIndex-1)" :actName="actName" />
            </div>
          </b-tab>
          
          <b-tab>
            <template #title>
              <div class="tab-title">
                <i class="tab-icon">⏳</i>
                <span>審核中</span>
              </div>
            </template>
            <div class="tab-panel">
              <Actable v-if="newIndex-1==1" :ids="converts(newIndex-1)" :actName="actName" />
            </div>
          </b-tab>
          
          <b-tab active>
            <template #title>
              <div class="tab-title">
                <i class="tab-icon">✅</i>
                <span>已發佈</span>
              </div>
            </template>
            <div class="tab-panel">
              <Actable v-if="newIndex-1==2" :ids="converts(newIndex-1)" :actName="actName" />
            </div>
          </b-tab>
          
          <b-tab>
            <template #title>
              <div class="tab-title">
                <i class="tab-icon">🏁</i>
                <span>結束</span>
              </div>
            </template>
            <div class="tab-panel">
              <Actable v-if="newIndex-1==3" :ids="converts(newIndex-1)" :actName="actName" />
            </div>
          </b-tab>
          
          <b-tab v-if="defaultval.type=='town' || defaultval.type=='county'">
            <template #title>
              <div class="tab-title">
                <i class="tab-icon">📊</i>
                <span>報表</span>
              </div>
            </template>
            <div class="tab-panel">
              <Act_report/>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import Act_report from "./Act_report.vue"
import Actable from "./Act_table.vue"
import ActableTmp from "./Act_table_tmp.vue"
import * as moment from "moment/moment";
import { mapState } from "vuex";

export default {
  name: 'Act_topbar',  
  components: {
    Actable, 
    ActableTmp,
    Act_report,
  },     
  data() {
    return {
      newIndex:3,
      actName:"all",
    };
  },
  computed: {
    ...mapState("makeorg", ["defaultval"])
  },
  mounted() {
    this.restoreTabState();
  },  
  methods: {
  restoreTabState() {
    const queryNewTabIndex = sessionStorage.getItem('queryNewTabIndex');
    if (queryNewTabIndex) {
      const savedState = JSON.parse(queryNewTabIndex);    
      this.$nextTick(() => {
        this.newIndex = savedState.page;  // 确保更新是在下一个事件循环，增加响应性
      });
    }
  },

  tabActivated(newTabIndex){
      const myIndex = sessionStorage.getItem('queryNewTabIndex');
      if (myIndex) {
        let savedState = JSON.parse(myIndex);
        if(newTabIndex!==savedState.page){
            window.sessionStorage.removeItem('queryTableState')
        }      
      }              
      this.newIndex =  newTabIndex  
      let queryNewTabIndex={
        page: this.newIndex,
      }
      window.sessionStorage.setItem('queryNewTabIndex', JSON.stringify(queryNewTabIndex));
  },       
  converts(val){
    let tmp = "Y";
      val == 0 ? tmp ="N" : "";
      val == 1 ? tmp ="I" : "";
      val == 2 ? tmp ="Y" : "";
      val == 3 ? tmp ="F" : "";      
      return tmp;
  },

  async onSearch(value) {
      if (value == "") {
        this.actName = "all";
      } else {
        this.actName = value;
      }
  },   

  fdateformat(val){
        return moment(val).format("YYYY-MM-DD"); 
    },
  },
};
</script>

<style scoped>
/* 主容器 */
.act-topbar-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  min-height: 100vh;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 頁面標題區域 */
.header-section {
  background: #ffffff;
  padding: 32px 40px 24px 40px;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.page-title {
  text-align: left;
}

.title-text {
  font-size: 26px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  letter-spacing: -0.025em;
}

.subtitle-text {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  font-weight: 400;
}

/* 內容區域 */
.content-section {
  padding: 32px 0;
  width: 100%;
}

/* 搜尋區域 */
.search-section {
  margin-bottom: 32px;
  padding: 0 40px;
  display: flex;
  justify-content: flex-start;
}

.search-input {
  max-width: 480px;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-input .ant-input {
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 16px;
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.search-input .ant-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-input .ant-input-search-button {
  border-radius: 0 12px 12px 0;
  background: #3b82f6;
  border-color: #3b82f6;
  font-weight: 500;
  transition: all 0.2s ease;
}

.search-input .ant-input-search-button:hover {
  background: #2563eb;
  border-color: #2563eb;
  transform: translateY(-1px);
}

/* Tabs 容器 */
.tabs-container {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #f1f5f9;
  width: 100%;
  margin: 0;
}

/* Tab 標題樣式 */
.tab-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  font-weight: 500;
  font-size: 15px;
  transition: all 0.2s ease;
}

.tab-icon {
  font-size: 16px;
  filter: grayscale(1);
  transition: all 0.2s ease;
}

/* Tab 面板內容 */
.tab-panel {
  padding: 24px;
  background: #ffffff;
  min-height: 400px;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .header-section {
    padding: 24px 20px 20px 20px;
  }
  
  .title-text {
    font-size: 24px;
  }
  
  .subtitle-text {
    font-size: 14px;
  }
  
  .content-section {
    padding: 24px 0;
  }
  
  .search-section {
    padding: 0 20px;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .tab-title {
    font-size: 14px;
    gap: 6px;
  }
  
  .tab-icon {
    font-size: 14px;
  }
  
  .tab-panel {
    padding: 16px;
  }
}

/* 自定義滾動條 */
.content-section::-webkit-scrollbar {
  width: 6px;
}

.content-section::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 3px;
}

.content-section::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  transition: background 0.2s ease;
}

.content-section::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>

<style>
/* 全局 Tab 樣式覆蓋 */
.nav-tabs-custom {
  border-bottom: none !important;
  background: #f8fafc !important;
  padding: 8px 8px 0 8px !important;
  margin: 0 !important;
}

.nav-tabs-custom .nav-item {
  margin-bottom: 0 !important;
  margin-right: 4px !important;
}

.nav-tabs-custom .nav-link {
  border: none !important;
  background: transparent !important;
  color: #6b7280 !important;
  padding: 12px 20px !important;
  border-radius: 12px 12px 0 0 !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  position: relative !important;
}

.nav-tabs-custom .nav-link:hover {
  background: #ffffff !important;
  color: #374151 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.nav-tabs-custom .nav-link.active {
  background: #ffffff !important;
  color: #1f2937 !important;
  border-bottom: 3px solid #3b82f6 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.nav-tabs-custom .nav-link.active .tab-icon {
  filter: none !important;
  animation: bounce 0.3s ease !important;
}

.tab-content-custom {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* 動畫效果 */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-3px);
  }
  60% {
    transform: translateY(-1px);
  }
}

/* 載入動畫 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tab-panel {
  animation: fadeIn 0.3s ease !important;
}

/* 移除舊樣式 */
.hidden_cssd {
  border-top: 1px solid #f1f1f0; 
  border-bottom: 3px solid #ebebe8;
  border-style: dotted;
}
</style>